export const sortGridElementsByLabel = (a, b) => {
  const labelComparison = a.label.localeCompare(b.label);

  if (labelComparison !== 0) {
    return labelComparison;
  }

  return a.value.localeCompare(b.value);
};
